import ReflectionEmojiType from "../ReflectionTypes/ReflectionEmojiType/ReflectionEmojiType";
import ReflectionLikeType from "../ReflectionTypes/ReflectionLikeType/ReflectionLikeType";
import ReflectionNumbersType from "../ReflectionTypes/ReflectionNumbersType/ReflectionNumbersType";
import ReflectionOpenType from "../ReflectionTypes/ReflectionOpenType/ReflectionOpenType";

export const ReflectionComponentsEnum = {
    OpenText: ReflectionOpenType,
    YesNo: ReflectionLikeType,
    Emoji: ReflectionEmojiType,
    Numbers: ReflectionNumbersType
};